import * as React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { MenuItem } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { FireBaseContext } from "../../Context/FireBase";
import { doc, getDoc } from "firebase/firestore";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import { HelperContext } from "../../Context/HelperContext";


const TOVsDropDownReport = ({ data, filename }) => {
   
  const tovOptions = [
    { types: "Accommodation" },
    { types: "CME Hours" },
    { types: "Flights" },
    { types: "Meals" },
    { types: "Registration Fees" },
    { types: "Medical Utilities" },
    { types: "Transportation" },
    { types: "Visa" },
  ];

  const [selectedTov, setSelectedTov] = useState("");
  const { TransferOfValuesRef, EventRefrence, EventsDeletedRef } = useContext(FireBaseContext);
  const { FormateDate } = useContext(HelperContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const open = Boolean(anchorEl);


  const handleExportStart = () => {
    setIsExporting(true); // Show spinner
  };

  const handleExportEnd = () => {
    setIsExporting(false); // Hide spinner
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    const index = parseInt(event.currentTarget.getAttribute("data-value"), 10);
    if (index >= 0 && index < tovOptions.length) {
      setSelectedTov(tovOptions[index].types);
    }
    setAnchorEl(null);
  };

  useEffect(() => {
    if (selectedTov) {
      getFirebaseDocument();
    }
  }, [selectedTov]);

  const getFirebaseDocument = async () => {
    const targetDoc = await getDoc(doc(TransferOfValuesRef, selectedTov));
    const dataList = targetDoc.exists() ? targetDoc.data().data : [];
    let totalCost = 0;
    let totalCostEvent = 0;

    const extractData = await Promise.all(
      dataList.map(async (item) => {
        let eventCost = 0;

        const deletedEventsRef = await getDoc(doc(EventsDeletedRef, item.eventID));
        if (deletedEventsRef.exists()) {
          return false;
        }

        // Fetch event cost from Firebase
        const ref = doc(EventRefrence, item.eventID);
        const dataEvent = await getDoc(ref);

        if (dataEvent.exists()) {
          eventCost = dataEvent.data().eventCost;
          totalCostEvent += eventCost;
        }

        // Sum total cost
        totalCost += Number(item.value);
        return {
          "Event Name": item.eventName,
          "Event Date": FormateDate(item.eventDate),
          "Event Cost": eventCost,
          Value: item.value,
        };
      })
    );

    let extractDataFilter = extractData.filter((item) => {
      return item !== false;
    });
    

    await exportToExcel(extractDataFilter, totalCost, totalCostEvent);
  };

  const exportToExcel = async (extractDataFilter, totalCost, totalCostEvent) => {
    handleExportStart();
    const filename = `${selectedTov} Report`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("tov sheet");
    const headersList = ["Event Name", "Event Date", "Value", "Event Cost"];
    worksheet.addRow([...headersList]);

    const row = worksheet.getRow(1);
    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "80FFFF00" },
      };
      cell.font = { size: 12 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    extractDataFilter.map((rowItem, index) => {
      const holder = [
        ...headersList.map((head) => {
          const convertItem = isNaN(Number(rowItem[head]))
            ? rowItem[head]
            : Number(rowItem[head]);
          return rowItem[head] ? convertItem : "";
        }),
      ];
      worksheet.addRow([...holder]);
      if (index + 1 === extractDataFilter.length) {
        worksheet.addRow([...Array(2).fill(""), totalCost, totalCostEvent]);
        const row = worksheet.getRow(extractDataFilter.length + 2);
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFADD8E6" },
          };
          cell.alignment = { horizontal: "center", vertical: "middle" };
        });
      }
      const rowIndex = index + 2;
      const row = worksheet.getRow(rowIndex);
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
    });

    worksheet.columns.forEach((column, colIndex) => {
      let maxLength = 0;

      worksheet.eachRow({ includeEmpty: true }, (row) => {
        const cellValue = row.getCell(colIndex + 1).text;
        maxLength = Math.max(maxLength, cellValue ? cellValue.length : 0);
      });

      column.width = maxLength + 5;
    });

    worksheet.getRow(1).height = 20;
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, filename);
    handleExportEnd();
  };

  return (
    <div>
      <Button
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="flex justify-center items-center gap-2   "

      >
        {isExporting ? (
          <i className="gg-spinner-two-alt fs-5 text-white animate-spin"></i>
        ) : (
          <i className="fa-solid fa-file-arrow-down fs-5 text-white"></i>
        )}
        <span className="text-white block leading-4">Tov Report</span>


      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {tovOptions.map((tov, index) => (
          <MenuItem key={tov.types} data-value={index} onClick={handleClose}>
            {tov.types}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default TOVsDropDownReport;
